import type { GetStaticProps, NextPage } from "next";
import Head from "next/head";
import Contact from "components/Contact";
import Layout from "components/Layout";
import { useEffect, useState } from "react";
import { serverSideTranslations } from "next-i18next/pages/serverSideTranslations";
const Home: NextPage<any> = (props: {
  locale: string;
}) => {
  const [key, setKey] = useState(0);
  useEffect(() => {
    setKey(key + 1);
  }, [props.locale]);
  return <div style={{
    position: "relative",
    overflow: "hidden"
  }}>
      <Head>
        <title>ZenClass - Teach Your Way </title>
        <meta name="description" content="Teach your way - The adaptive learning platform that makes education brilliant" />
        <link rel="icon" href="/favicon.ico" />

        <meta property="og:title" content="ZenClass - Teach Your Way" />
        <meta property="og:image" content="https://zenclass.co/v3/logo.jpg" />
        <meta property="og:description" content="Teach your way - The adaptive learning platform that makes education brilliant" />

        <meta name="twitter:title" content="ZenClass - Teach Your Way" />
        <meta name="twitter:image" content="https://zenclass.co/v3/logo.jpg" />
        <meta name="twitter:description" content="Teach your way - The adaptive learning platform that makes education brilliant" />
      </Head>
      <Layout activeHeader={true} locale={props.locale}>
        <div key={key}>
          <Contact />
        </div>
      </Layout>
    </div>;
};
export const getStaticProps: GetStaticProps = async ctx => {
  return {
    props: {
      ...(await serverSideTranslations(ctx.locale ?? 'en', ['common'])),
      locale: ctx.locale
    }
  };
};
export default Home;